"use strict";
/**
 * Календарные дни и одно правило просрочки на всю систему.
 *
 * Правило: срок — это день, а не момент. Пока идёт сам день срока, работа
 * не просрочена: у человека есть время до конца дня. Просрочка начинается
 * со следующего утра.
 *
 * Раньше правило было записано в пяти местах по-разному. Лента уведомлений
 * сравнивала срок с текущим временем и с 00:01 показывала «просрочено на
 * 0 дней» — фразу, которая сама себя опровергает. Таймлайн рисовал красную
 * рамку в то же время, а календарь и сводка сроков — нет. Один и тот же
 * элемент выглядел одновременно просроченным и нет, в зависимости от того,
 * на какую страницу человек смотрел.
 *
 * Поэтому правило живёт здесь, в общем пакете: и сервер, и браузер обязаны
 * спрашивать одну и ту же функцию, а не каждый писать своё сравнение.
 *
 * День считается в часовом поясе отображения, а не в UTC. Для Берлина UTC
 * отстаёт на час-два, и вечер 25-го по UTC — уже 26-е по-берлински: срок
 * «завтра» показался бы просроченным за несколько часов до полуночи.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPLAY_TIMEZONE = void 0;
exports.dayKey = dayKey;
exports.todayKey = todayKey;
exports.daysUntilDay = daysUntilDay;
exports.isOverdue = isOverdue;
exports.isDueToday = isDueToday;
exports.overdueBefore = overdueBefore;
exports.startOfDay = startOfDay;
exports.shiftDayKey = shiftDayKey;
/** Часовой пояс отображения дат в интерфейсе. В базе всегда UTC. */
exports.DISPLAY_TIMEZONE = 'Europe/Berlin';
/** «ГГГГ-ММ-ДД» — тот же порядок, что у ключа дня, поэтому en-CA. */
const dayKeyFormatter = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: exports.DISPLAY_TIMEZONE,
});
/** Уже готовый ключ дня, который не нужно переводить через часовой пояс. */
const DAY_KEY = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
/** Ключ дня «ГГГГ-ММ-ДД» в часовом поясе отображения. */
function dayKey(value) {
    if (typeof value === 'string' && DAY_KEY.test(value))
        return value;
    const date = typeof value === 'string' ? new Date(value) : value;
    return dayKeyFormatter.format(date);
}
/** Сегодняшний день в часовом поясе отображения. */
function todayKey(now = new Date()) {
    return dayKeyFormatter.format(now);
}
/**
 * Сколько дней осталось до дня `day`: 0 — сегодня, 1 — завтра,
 * отрицательное — прошлое.
 */
function daysUntilDay(day, now = new Date()) {
    return Math.round((Date.parse(`${dayKey(day)}T00:00:00Z`) - Date.parse(`${todayKey(now)}T00:00:00Z`)) /
        86_400_000);
}
/**
 * Просрочено ли. Сегодняшний срок — не просрочка.
 *
 * Без срока просрочки быть не может: пустое значение возвращает `false`,
 * а не бросает, потому что срок необязателен у большинства типов.
 */
function isOverdue(due, now = new Date()) {
    if (!due)
        return false;
    return dayKey(due) < todayKey(now);
}
/** Наступает ли срок сегодня. */
function isDueToday(due, now = new Date()) {
    if (!due)
        return false;
    return dayKey(due) === todayKey(now);
}
/**
 * Граница просрочки как момент времени — для запросов к базе.
 *
 * Всё, что строго раньше, просрочено. Колонки сроков объявлены как `@db.Date`,
 * и Postgres приведёт эту границу к дате, отбросив время.
 */
function overdueBefore(now = new Date()) {
    return new Date(`${todayKey(now)}T00:00:00.000Z`);
}
/** Начало дня `day` как момент времени — для запросов к базе. */
function startOfDay(day) {
    return new Date(`${dayKey(day)}T00:00:00.000Z`);
}
/** День через `count` дней от сегодняшнего, ключом. */
function shiftDayKey(day, count) {
    const shifted = new Date(Date.parse(`${dayKey(day)}T00:00:00Z`) + count * 86_400_000);
    return shifted.toISOString().slice(0, 10);
}
//# sourceMappingURL=dates.js.map